import React from "react";
import "./ArticleCard.css";

const ArticleCard = ({ title, summary, link }) => {
  return (
    <div className="article-card">
      <h3 className="article-title">{title}</h3>
      <p className="article-summary">{summary}</p>
      {link && (
        <a
          className="article-link"
          href={link}
          target="_blank"
          rel="noopener noreferrer"
        >
          <p className="paperclip-icon">&#128206;</p> Visit Article
        </a>
      )}
    </div>
  );
};

export default ArticleCard;
